import { render, staticRenderFns } from "./ReactionTestsTab.vue?vue&type=template&id=5d3f32a1&"
import script from "./ReactionTestsTab.vue?vue&type=script&lang=js&"
export * from "./ReactionTestsTab.vue?vue&type=script&lang=js&"
import style0 from "./ReactionTestsTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReactionTestsTab.vue"
export default component.exports